export default {
  name: `Additional Worksites`,
  prefix: "F.b",
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        isVisible: {
          when: "occupationType",
          is: ["professional_athlete"],
          operator: "||",
        },
        title: "Section Complete",
        description:
          "Because you indicated that this application is for a Professional Athlete, this section is not necessary.",
        type: "success",
      },
    ],
  },
  pageInfo: {
    isVisible: {
      when: "occupationType",
      is: [
        "professional_occupation",
        "non_professional",
        "college_university_teacher",
        "",
      ],
      operator: "||",
    },
    text: `<b><u>Note:</u></b> Additional worksites must be one or more of the additional worksites identified in Appendix A of the 
    Form ETA-9141 for this specific job opportunity and must have the appropriate wage offer rate.  Worksites within the same Bureau of 
    Labor Statistics (BLS) Area (Metropolitan or Non-Metropolitan Statistical Areas) should also be listed if a Notice of Filing will be posted at that location.`,
    coloring: "grey",
  },
  sections: [
    {
      isVisible: {
        when: "occupationType",
        is: [
          "professional_occupation",
          "non_professional",
          "college_university_teacher",
          "",
        ],
        operator: "||",
      },
      fields: [
        {
          isGroup: {
            code: "F.b.1",
            machine_name: "isMultipleLocations",
            required: true,
            label: `Will work be performed in geographic areas other than the one identified in Section F.a?`,
            tooltip: `If “No <u>one</u> specific worksite or physical location” is marked in question F.a.1 <u><b>or</b></u> the employer’s job opportunity will be performed in geographic areas other than the one disclosed in Section F.a. of this application, including geographic areas with multiple county-level PWDs, mark “Yes.”  Otherwise, mark “No.”`,
            clearBtn: {
              clearSchema: ["isMultipleLocations"],
              hide: {
                when: "primaryWorksiteType",
                is: "4",
              },
            },
            warnings: [
              {
                text: "Marking No in section F.b.1 will mark your submission as No to F.b.2 and Appendix B is not required",
                isVisible: {
                  when: "isMultipleLocations",
                  is: "No",
                },
              },
            ],
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
                setSchema: [
                  { set: "appx_b", to: [] },
                  { set: "isAppdendixBAttached", to: 1 },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                setSchema: [
                  { set: "isAppdendixBAttached", to: 0 },
                  { set: "appx_b", to: [] },
                ],
                disabled: true,
                disableWhenField: (values) => {
                  return values.primaryWorksiteType === "4";
                },
              },
            ],
          },
        },
        {
          isVisible: {
            when: "occupationType",
            is: [
              "professional_occupation",
              "non_professional",
              "college_university_teacher",
              "",
            ],
            operator: "||",
            hideStyles: true,
          },
          code: "F.b.2",
          machine_name: "isAppdendixBAttached",
          widget: "jump_to_step",
          label: `If "yes" is marked in question F.b.1 indicate whether a completed Appendix B is attached to this application. §`,
          tooltip:
            "If the answer to question F.b.1 is “Yes,” indicate whether the employer has attached to this application a completed <b>Appendix B</b> by selecting “Yes” or “No.”  If the answer to question F.b.1 is “No,” mark “N/A.”",
          jump_to_step: {
            buttonPrimary: "Go to Appendix B",
            step: 20,
          },
        },
      ],
    },
  ],
};
